<template>
  <div>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">
            <span v-if="count !== 0">{{ count }} </span>
            <span>{{ $t("pageHeader.comment") }}</span>
          </h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout
          class="pt-2 pl-2 pr-2"
          align-start="align-start"
          justify-center="justify-center"
          row="row"
        >
          <v-avatar size="40px">
            <img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" alt="User" />
            <img v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-avatar>
          <v-layout class="ml-2 mr-2" column>
            <v-flex>
              <v-textarea
                class="mt-0 pt-0"
                v-model="comment"
                placeholder="Add a comment...."
                auto-grow="auto-grow"
                hide-details="hide-details"
                rows="1"
              >
              </v-textarea>
            </v-flex>
            <v-flex class="pt-0 text-xs-right" v-if="comment">
              <v-btn flat="flat" @click="cancel">cancel</v-btn>
              <v-btn color="info" @click="saveComment">comment</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-progress-linear v-if="loading" size="70" width="7" indeterminate="indeterminate">
        </v-progress-linear>
        <v-container>
          <v-layout column v-if="!loading">
            <template v-for="(row, index) in comments">
              <v-layout class="pointer" column>
                <v-flex v-if="!ownerID">
                  <v-layout row>
                    <v-avatar size="35px">
                      <img
                        v-if="row.User && row.User.imageUrl"
                        :src="row.User.imageUrl"
                        alt="User"
                      />
                      <img v-else src="../../../assets/images/user.jpeg" alt="User" />
                    </v-avatar>
                    <v-flex>
                      <v-layout column>
                        <v-flex>
                          <v-layout row>
                            <v-flex xs12 sm10 md8>
                              <v-layout row wrap>
                                <div class="ml-2 body-2 font-weight-medium" v-if="row.User">
                                  {{ row.User.fullName }}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="text-xs-right mr-3">
                                  {{ row.createDateTime | moment("from", "now") }}
                                </div>
                              </v-layout>

                              <v-card color="info" dark style="border-radius: 0 20px 20px 20px;">
                                <v-card-text>
                                  <div class="font-weight-regular">
                                    <span>{{ row.comment }}</span>
                                  </div>
                                </v-card-text>
                              </v-card>
                              <v-layout row wrap>
                                <div v-if="row.replyCount !== 0">
                                  <v-expansion-panel
                                    class="elevation-0"
                                    v-model="panel[row.commentID]"
                                    expand="expand"
                                  >
                                    <v-expansion-panel-content hide-actions>
                                      <template v-slot:header>
                                        <div class="font-weight-regular">
                                          {{ panelName(row)
                                          }}<v-icon
                                            v-if="panel[row.commentID] && panel[row.commentID][0]"
                                            >keyboard_arrow_up</v-icon
                                          >
                                          <v-icon v-else>keyboard_arrow_down</v-icon>
                                        </div>
                                      </template>
                                      <CommentReply
                                        :commentID="row.commentID"
                                        :key="row.replyCount"
                                        v-if="panel[row.commentID]"
                                      >
                                      </CommentReply>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="grey--text"
                                  flat="flat"
                                  small="small"
                                  right="right"
                                  @click="reply(row)"
                                >
                                  <v-icon>reply</v-icon>reply</v-btn
                                >
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex v-else-if="ownerID === row.userID">
                  <v-layout row>
                    <v-avatar size="35px">
                      <img
                        v-if="row.User && row.User.imageUrl"
                        :src="row.User.imageUrl"
                        alt="User"
                      />
                      <img v-else src="../../../assets/images/user.jpeg" alt="User" />
                    </v-avatar>
                    <v-flex>
                      <v-layout column>
                        <v-flex>
                          <v-layout row>
                            <v-flex xs12 sm10 md8>
                              <v-layout row wrap>
                                <div class="ml-2 body-2 font-weight-medium" v-if="row.User">
                                  {{ row.User.fullName }}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="text-xs-right mr-3">
                                  {{ row.createDateTime | moment("from", "now") }}
                                </div>
                              </v-layout>

                              <v-card color="info" dark style="border-radius: 0 20px 20px 20px;">
                                <v-card-text>
                                  <div class="font-weight-regular">
                                    <span>{{ row.comment }}</span>
                                  </div>
                                </v-card-text>
                              </v-card>
                              <v-layout row wrap>
                                <div v-if="row.replyCount !== 0">
                                  <v-expansion-panel
                                    class="elevation-0"
                                    v-model="panel[row.commentID]"
                                    expand="expand"
                                  >
                                    <v-expansion-panel-content hide-actions>
                                      <template v-slot:header>
                                        <div class="font-weight-regular">
                                          {{ panelName(row)
                                          }}<v-icon
                                            v-if="panel[row.commentID] && panel[row.commentID][0]"
                                            >keyboard_arrow_up</v-icon
                                          >
                                          <v-icon v-else>keyboard_arrow_down</v-icon>
                                        </div>
                                      </template>
                                      <CommentReply
                                        :commentID="row.commentID"
                                        :key="row.replyCount"
                                        v-if="panel[row.commentID]"
                                      >
                                      </CommentReply>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="grey--text"
                                  flat="flat"
                                  small="small"
                                  right="right"
                                  @click="reply(row)"
                                >
                                  <v-icon>reply</v-icon>reply</v-btn
                                >
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex v-else>
                  <v-layout row>
                    <v-flex>
                      <v-layout column>
                        <v-flex>
                          <v-layout row>
                            <v-flex offset-md4 offset-sm2 xs12 sm10 md8>
                              <v-layout row wrap>
                                <div class="text-xs-right ml-3">
                                  {{ row.createDateTime | moment("from", "now") }}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="mr-2 body-2 font-weight-medium" v-if="row.User">
                                  {{ row.User.fullName }}
                                </div>
                              </v-layout>
                              <v-card
                                color="grey lighten-3"
                                style="border-radius: 20px 0 20px 20px;"
                              >
                                <v-card-text>
                                  <div class="font-weight-regular">
                                    <span>{{ row.comment }}</span>
                                  </div>
                                </v-card-text>
                              </v-card>
                              <v-layout row wrap>
                                <v-btn class="grey--text" flat small @click="reply(row)">
                                  <v-icon>reply</v-icon>reply</v-btn
                                >
                                <v-spacer></v-spacer>
                                <div v-if="row.replyCount !== 0">
                                  <v-expansion-panel
                                    class="elevation-0"
                                    v-model="panel[row.commentID]"
                                    expand="expand"
                                  >
                                    <v-expansion-panel-content hide-actions>
                                      <template v-slot:header>
                                        <div class="font-weight-regular">
                                          {{ panelName(row)
                                          }}<v-icon
                                            v-if="panel[row.commentID] && panel[row.commentID][0]"
                                            >keyboard_arrow_up</v-icon
                                          >
                                          <v-icon v-else>keyboard_arrow_down</v-icon>
                                        </div>
                                      </template>
                                      <CommentReply
                                        :commentID="row.commentID"
                                        :key="row.replyCount"
                                        v-if="panel[row.commentID]"
                                      >
                                      </CommentReply>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-avatar size="35px">
                      <img
                        v-if="row.User && row.User.imageUrl"
                        :src="row.User.imageUrl"
                        alt="User"
                      />
                      <img v-else src="../../../assets/images/user.jpeg" alt="User" />
                    </v-avatar>
                  </v-layout>
                </v-flex>
              </v-layout>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text class="pt-0" v-if="loadedData !== count">
        <v-btn flat="flat" block="block" @click="getMoreData">load more</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import commentService from "../service.js";
import CommentReply from "./CommentReply";
import { mapGetters } from "vuex";

export default {
  props: ["refID", "typeId", "ownerID"],
  data() {
    return {
      limit: 10,
      count: 0,
      loadedData: 0,
      panel: {},
      comment: null,
      comments: [],
      loading: true
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  created() {
    this.getList();
  },
  watch: {
    refID() {
      this.getList();
    }
  },
  components: {
    CommentReply
  },
  methods: {
    panelName(val) {
      let commentLength = val.replyCount;
      let name = null;
      if (commentLength > 1) {
        name = `View ${commentLength} replies`;
      } else {
        name = "View reply";
      }

      if (this.panel[val.commentID] && this.panel[val.commentID][0]) {
        return "Hide replies";
      }
      {
        return name;
      }
    },
    cancel() {
      this.comment = null;
    },
    save(data) {
      return commentService.create(data).then(result => {
        this.comment = null;
        this.getList();
        this.$emit("commentCreated", data);
      });
    },
    saveComment() {
      this.save({
        storeID: this.refID,
        referenceID: this.refID,
        typeID: this.typeId,
        comment: this.comment
      });
    },
    async reply(comment) {
      const { value: text } = await this.$swal.fire({
        title: "New Comment",
        text: comment.comment,
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true
      });
      if (text) {
        this.save({
          storeID: this.refID,
          referenceID: this.refID,
          typeID: this.typeId,
          comment: text,
          displayRelationID: comment.commentID
        });
      }
    },
    getMoreData() {
      this.limit += 10;
      this.getList();
    },
    getList() {
      return commentService
        .getCommentByID({ typeId: this.typeId, id: this.refID, limit: this.limit })
        .then(response => {
          console.log("response", response);
          this.comments = response.data.rows;
          this.loadedData = response.data.rows.length;
          this.count = response.data.count;
          this.loading = false;
          return response;
        });
    }
  }
};
</script>

<style scoped></style>
